import { Controller } from '@hotwired/stimulus'

// Podio de la portada de cuentas (ENH-RNK-7023): una sola vez, en el primer scroll con la
// tarjeta 1 a la vista (al menos el 20 %), las tres dan un salto pequeño una tras otra y
// después vibra la 1. El salto lo pinta el CSS mientras la tarjeta lleva `data-salto`. Con
// «reducir movimiento» no se hace nada.
export default class extends Controller {
  static targets = ['tarjeta']

  connect () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    this.alHacerScroll = this.alHacerScroll.bind(this)
    window.addEventListener('scroll', this.alHacerScroll, { passive: true })
  }

  disconnect () {
    window.removeEventListener('scroll', this.alHacerScroll)
    clearTimeout(this.finDelSalto)
    this.tarjetaTargets.forEach((tarjeta) => delete tarjeta.dataset.salto)
  }

  alHacerScroll () {
    const primera = this.tarjetaTargets[0]
    if (!primera || window.scrollY <= 0) return

    const caja = primera.getBoundingClientRect()
    if (caja.top > window.innerHeight - caja.height * 0.2) return

    window.removeEventListener('scroll', this.alHacerScroll)
    this.tarjetaTargets.forEach((tarjeta, indice) => { tarjeta.dataset.salto = indice + 1 })
    this.finDelSalto = setTimeout(() => {
      this.tarjetaTargets.forEach((tarjeta) => delete tarjeta.dataset.salto)
    }, 1600)
  }
}
